import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Mappa delle traduzioni con import dinamici
const translationLoaders: Record<string, () => Promise<any>> = {
  it: () => import("./locales/it.json"),
  en: () => import("./locales/en.json"),
  de: () => import("./locales/de.json"),
};

// Backend personalizzato che usa import dinamici
const DynamicImportBackend = {
  type: "backend" as const,
  init: () => {},
  read: async (
    language: string,
    namespace: string,
    callback: (err: Error | null, data: any) => void,
  ) => {
    try {
      const loader = translationLoaders[language];
      if (!loader) {
        throw new Error(`Translation not found for language: ${language}`);
      }
      const translations = await loader();
      callback(null, translations.default || translations);
    } catch (error) {
      callback(error as Error, null);
    }
  },
};

i18n
  .use(DynamicImportBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "it",
    supportedLngs: ["it", "en", "de"],
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
